import jwtDecode from 'jwt-decode'
import { TokenPayload } from '@jibo-cloud/service-common'

let accessToken = localStorage.getItem('accessToken')
let refreshToken = localStorage.getItem('refreshToken')
const reconnectServices = async () => {}

export function getAccessToken () {
  return accessToken
}

export async function setTokens (tokens) {
  accessToken = tokens?.token
  refreshToken = tokens?.token

  if (tokens) {
    localStorage.setItem('accessToken', accessToken)
    localStorage.setItem('refreshToken', refreshToken)
  } else {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
  }

  await reconnectServices()
}

export function getAuth (): TokenPayload {
  return accessToken ? jwtDecode(accessToken) : null
}

export function isLoggedIn (): boolean {
  return !!getAuth()
}

export function isAdmin (): boolean {
  const auth = getAuth()
  return auth && !!auth.authorization.permissions.find((p) => {
    return p.rsname === 'jiboServiceQAS' &&
        (p.scopes.includes('transactionUpdate' as any) || p.scopes.includes('annotationUpdate' as any) || p.scopes.includes('metadataUpdate' as any))
  })
}

export function isReviewer (): boolean {
  const auth = getAuth()
  return auth && !!auth.authorization.permissions.find((p) => {
    return p.rsname === 'jiboServiceQAS' &&
        (p.scopes.includes('transactionRead' as any) || p.scopes.includes('annotationRead' as any) || p.scopes.includes('metadataRead' as any))
  })
}
